import apiClient from './api';
import { Subscriber } from '../types/subscriber'; // تأكد من وجود هذا النوع
import { SubscriberStatus } from '../types/enums'; // تأكد من وجود هذا النوع
import { PagedResult, TableParams } from '../hooks/useServerSideTable';

// نوع بيانات لتحديث مشترك
export interface UpdateSubscriberData {
  name?: string;
  phone?: string;
  qualification?: string;
  graduation_year?: number;
  status?: SubscriberStatus;
}

/**
 * جلب قائمة المشتركين مع دعم للترقيم والبحث والفرز
 */
export const getPagedSubscribers = async (params: TableParams): Promise<PagedResult<Subscriber>> => {
  const response = await apiClient.get<{ data: PagedResult<Subscriber> }>('/subscribers/paged', { params });
  return response.data.data;
};

/**
 * جلب مشترك بواسطة ID
 */
export const getSubscriberById = async (id: number): Promise<Subscriber> => {
  const response = await apiClient.get<{ data: Subscriber }>(`/subscribers/${id}`);
  return response.data.data;
};

/**
 * تحديث مشترك موجود
 */
export const updateSubscriber = async (id: number, subscriberData: UpdateSubscriberData): Promise<Subscriber> => {
  const response = await apiClient.put<{ data: Subscriber }>(`/subscribers/${id}`, subscriberData);
  return response.data.data;
};

/**
 * حذف مشترك بواسطة ID
 */
export const deleteSubscriber = async (id: number): Promise<void> => {
  await apiClient.delete(`/subscribers/${id}`);
};

/**
 * الموافقة على مشترك
 */
export const approveSubscriber = async (id: number): Promise<Subscriber> => {
  const response = await apiClient.patch<{ data: Subscriber }>(`/subscribers/${id}/approve`);
  return response.data.data;
};

/**
 * رفض مشترك
 */
export const rejectSubscriber = async (id: number): Promise<Subscriber> => {
  const response = await apiClient.patch<{ data: Subscriber }>(`/subscribers/${id}/reject`);
  return response.data.data;
};
